import { render, staticRenderFns } from "./ImgWrap.vue?vue&type=template&id=4d670547&"
import script from "./ImgWrap.vue?vue&type=script&lang=js&"
export * from "./ImgWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports